enum QuestionType {
  SingleChoice = 'SINGLE_CHOICE',
  MultiChoice = 'MULTI_CHOICE',
}

export default QuestionType
